import axios from "axios";
import { getAuthHeaders } from "./getAuthHeaders";

/**
 * Fetch all org-user groups from paginated GET /orgs/users.
 * Supports legacy bare-array responses.
 *
 * @param {string} endpoint
 * @param {{ organizationId?: number; search?: string; limit?: number }} [queryOverrides]
 */
export async function fetchAllOrgUsers(endpoint, queryOverrides = {}) {
  const limit = queryOverrides.limit ?? 100;
  const collected = [];
  let page = 1;
  let totalFromApi = null;

  while (true) {
    const response = await axios.get(endpoint, {
      params: {
        page,
        limit,
        organizationId: queryOverrides.organizationId,
        search: queryOverrides.search || undefined,
      },
      headers: {
        ...getAuthHeaders(),
        Accept: "*/*",
        "Content-Type": "application/json",
      },
    });

    const raw = response?.data;
    const chunk = Array.isArray(raw?.data)
      ? raw.data
      : Array.isArray(raw)
      ? raw
      : [];

    collected.push(...chunk);
    totalFromApi = typeof raw?.total === "number" ? raw.total : null;

    if (chunk.length === 0) break;
    if (totalFromApi != null && collected.length >= totalFromApi) break;
    if (chunk.length < limit) break;
    page += 1;
  }

  return collected;
}

/** Flatten org groups into picker rows keyed by user_index. */
export function flattenOrgUsersForPicker(orgGroups) {
  const list = Array.isArray(orgGroups) ? orgGroups : [];
  return list.flatMap((org) =>
    (org.users || [])
      .filter((user) => user?.isActive !== false)
      .map((user) => {
        const userIndex = Number(user.user_index ?? user.user_id);
        if (Number.isNaN(userIndex)) return null;
        return {
          userIndex,
          name: user.name || "",
          email: user.email || "",
          organizationId: org.organization_id,
          orgName: org.name || "—",
          userType: user.user_type || null,
        };
      })
      .filter(Boolean)
  );
}
